(() => {
  if (customElements.get('hartfield-product-copy')) return;
  class HartfieldProductCopy extends HTMLElement {
    connectedCallback() {
      if (this.dataset.prepared) return;
      this.dataset.prepared = 'true';
      const source = this.querySelector('[data-product-copy-source]');
      const details = this.querySelector('[data-product-details]');
      const destination = this.querySelector('[data-product-details-content]');
      if (!source || !details || !destination) return;
      source.querySelectorAll('*').forEach(node => {
        node.removeAttribute('class');
        node.removeAttribute('style');
        [...node.attributes].filter(attribute => attribute.name.startsWith('data-')).forEach(attribute => node.removeAttribute(attribute.name));
      });
      const generic = /^(description|details|product details|features|key features|additional details|specifications|diamond specifications)\s*:?$/i;
      const specifications = /^(material|metal|gemstones?|diamonds?|white diamonds?|champagne diamonds?|length|width|dimensions|size|flower size|reference|sku|product code|paving|stone quality|more details)\s*:/i;
      const children = [...source.children];
      let introShown = false;
      children.forEach(node => {
        const text = node.textContent.trim();
        if (!text) { node.remove(); return; }
        if (generic.test(text) && !node.querySelector('ul,ol,table')) { node.remove(); return; }
        if (node.matches('ul,ol,table') || specifications.test(text)) {
          destination.append(node);
          return;
        }
        if (node.matches('h1,h2,h3,h4,h5,h6')) {
          const paragraph = document.createElement('p');
          while (node.firstChild) paragraph.append(node.firstChild);
          node.replaceWith(paragraph);
          node = paragraph;
        }
        if (this.dataset.online === 'false') {
          const labelOnly = node.matches('p') && node.children.length === 1 && node.firstElementChild.matches('strong,b') && node.firstElementChild.textContent.trim() === text;
          if (labelOnly || introShown) destination.append(node);
          else introShown = true;
        }
      });
      const detailRank = node => {
        const text = node.textContent.trim();
        if (/^(material|metal)\s*:/i.test(text)) return 0;
        if (/^(gemstones?|diamonds?|white diamonds?|champagne diamonds?|stone quality|paving)\s*:/i.test(text)) return 1;
        if (/^(length|width|dimensions|size|flower size)\s*:/i.test(text)) return 2;
        if (/^(reference|sku|product code)\s*:/i.test(text)) return 4;
        return 3;
      };
      destination.querySelectorAll('ul,ol').forEach(list => {
        [...list.children].sort((a,b) => detailRank(a)-detailRank(b)).forEach(node => list.append(node));
      });
      [...destination.children].sort((a,b) => detailRank(a)-detailRank(b)).forEach(node => destination.append(node));
      if (destination.children.length) {
        details.hidden = false;
        details.open = false;
      }
      if (!source.textContent.trim()) this.querySelector('.hartfield-product-copy--intro').hidden = true;
    }
  }
  customElements.define('hartfield-product-copy', HartfieldProductCopy);
})();
